import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import TableItemCustomsIQ from "./TableItemCustomsIQ";
import TableItemAddOns from "./TableItemAddOns";
import postpalLogo from "../assets/svg/logo_blue.svg";
import TableItemDocuments from "./TableItemDocuments";
import { setActiveComponent, setActiveItem } from "../store/commonSlice";
import { useDispatch } from "react-redux";
import Arrow from '../assets/svg/arrow-down-circle.svg'

function CustomTable({
  headCells,
  rows,
  // setActiveDataName,
  packageActiveData,
  userActiveData,
  packageCollection,
  shipmentCollection,
}) {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [drawerForCustomIQ, setDrawerOpenForCustomIQ] = useState(false);
  const [dataForCustomIQDrawer, setDataForCustomIQDrawer] = useState(null);
  const [drawerForAddons, setDrawerOpenForAddOns] = useState(false);
  const [drawerForDocuments, setDrawerForDocuments] = useState({showDrawer:false,data:""});
  const [dataForAddOnDrawer, setdataForAddOnDrawer] = useState(null);

  // console.log("CustomTable", rows);
  console.log(userActiveData, "userActiveData in CustomTable");
  // console.log(
  //   packageCollection,
  //   shipmentCollection,
  //   "shipmentCollection in CustomTable"
  // );

  const toggleDrawerCustomIQ = (data, img) => {
    console.log(data,"dataaaaaaaaaaa");
    if (drawerForCustomIQ) {
      setDataForCustomIQDrawer("");
      setDrawerOpenForCustomIQ(!drawerForCustomIQ);
    } else {
      
      setDataForCustomIQDrawer(data);
      setDrawerOpenForCustomIQ(!drawerForCustomIQ);
    }
  };

  const toggleDrawerAddOns = (data, img) => {
    if (drawerForAddons) {
      setdataForAddOnDrawer("");
      setDrawerOpenForAddOns(!drawerForAddons);
    } else {
      setdataForAddOnDrawer(data);
      setDrawerOpenForAddOns(!drawerForAddons);
    }
  };
  const toggleDrawerDocuments = (data, img) => {
    console.log(data,"data in toggle");
    
    if (drawerForDocuments.showDrawer) {
      setDrawerForDocuments({showDrawer:false,data:null})
    } else {
      setDrawerForDocuments({showDrawer:true,data:data})
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  console.log(rows, "rows in in in");
  return (
    <>
      <Box>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {headCells.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      sx={{
                        textAlign:
                          column.label === "No" || column.label === "Qty"
                            ? "center"
                            : "left",
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <>
                    <TableRow key={row.no}>
                      {/* Render other table cells */}
                      <TableCell
                        align="center"
                        sx={{
                          //   minWidth: column.minWidth,
                          lineHeight: "10px !important",
                          height: "10px !important",
                        }}
                      >
                        {row.no}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          //   minWidth: column.minWidth,
                          lineHeight: "10px !important",
                          height: "10px !important",
                          cursor: "pointer",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          {row?.item_img ? (
                            <img
                              src={row?.item_img}
                              alt={"img"}
                              style={{
                                width: "28px",
                                height: "28px",
                                marginRight: "10px",
                              }}
                            />
                          ) : (
                            <img
                              src={postpalLogo}
                              alt={"postpalLogo"}
                              style={{
                                width: "28px",
                                height: "28px",
                                marginRight: "10px",
                              }}
                            />
                          )}
                          <Tooltip
                            title={row.fullName}
                            arrow
                            placement="bottom"
                          >
                            {row.fullName.split(' ').slice(0,3).join(' ') + "..."}
                          </Tooltip>
                          <img
                            src={Arrow}
                            alt={""}
                            style={{
                              width: "20px",
                              height: "20px",
                              marginLeft: "10px",
                            }}
                            onClick={() => {
                              console.log(row?.itemId,"row?.itemId in CustomTable");
                              dispatch(setActiveItem(row?.itemId))
                            }}
                          />
                        </Typography>
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          //   minWidth: column.minWidth,
                          lineHeight: "10px !important",
                          height: "10px !important",
                        }}
                      >
                        {row.qty}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          lineHeight: "10px !important",
                          height: "10px !important",
                          cursor: "pointer",
                        }}
                        onClick={() => toggleDrawerAddOns(row)} // onClick event for Add-ons
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          {row.addon}
                          <img
                            src={row.path}
                            alt={row.addon}
                            style={{ width: "20px", marginLeft: "10px" }}
                          />
                        </Box>
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          //   minWidth: column.minWidth,
                          lineHeight: "10px !important",
                          height: "10px !important",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          toggleDrawerCustomIQ(row)
                        }
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          {row.customiq}
                          <img
                            src={row.path}
                            alt={row.customiq}
                            style={{ width: "20px", marginLeft: "10px" }}
                          />
                        </Box>
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          //   minWidth: column.minWidth,
                          lineHeight: "10px !important",
                          height: "10px !important",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          toggleDrawerDocuments(row)
                        }
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={row.path}
                            alt={row.customiq}
                            style={{ width: "20px", marginLeft: "10px" }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                    <TableItemCustomsIQ
                      data={dataForCustomIQDrawer}
                      // img={imageForCustomIQDrawer}
                      open={drawerForCustomIQ}
                      onClose={toggleDrawerCustomIQ}
                      // selectedRows={row}
                    />
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              ".MuiTablePagination-toolbar": {
                maxHeight: "50px",
                overflow: "hidden",
              },
            }}
          />
        </Paper>
      </Box>
      <TableItemAddOns
        data={dataForAddOnDrawer}
        open={drawerForAddons}
        onClose={toggleDrawerAddOns}
        packageActiveData={packageActiveData}
        userActiveData={userActiveData}
        packageCollection={packageCollection}
        shipmentCollection={shipmentCollection}
      />
      <TableItemDocuments
        data={drawerForDocuments.data}
        open={drawerForDocuments.showDrawer}
        onClose={toggleDrawerDocuments}
      />
    </>
  );
}

export default CustomTable;
